import React, { Component } from 'react';
import './SubmitStyle.css';
import { Container, Col, Row } from 'react-bootstrap'
import Modal from 'react-modal'
import ClipLoader from "react-spinners/ClipLoader";
import axios from 'axios';
import moment from 'moment';
import api from 'lib/api';
import global from 'lib/global';


class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // isSubmit: false - 파일업로드 안보이기, true - 파일업로드 보이기
            isSubmit: false,
            visibleAlert: false,
            alert: '',

            message: 'memo',
            fileLoading: false, //피일 업로드중인지
            files: undefined,
            getData: {},
        }
    }

    componentDidMount() {
        this.loadEmailInfo();
    }

    loadEmailInfo = () => {
        const self = this;
        const code = this.props.match.params.code;

        api.post('/workbook/workbook/info', { code: code })
            .then(function (response) {
                if (response.data.result) {
                    self.setState({ getData: response.data.data });
                }
            })
            .catch(function (err) {

            })
    }


    handleAttachFile = (e) => {
        this.setState({ files: e.target.files });
    }

    onClickSubmitOnoff = () => {
        const getData = this.state.getData;
        if (Object.keys(this.state.getData).length === 0) {
            return;
        }

        if (getData.get_type > 0) {
            let dateNow = moment();
            let get_date = moment(getData.get_date);
            let diffHours = moment.duration(get_date.diff(dateNow)).asHours();
            if (diffHours < -3) {
                return; //학습지 제출완료
            }
        }

        //7일 지났는지 체크
        // if (getData.send_date) {
        //     let dateNow = moment();
        //     let send_date = moment(getData.send_date);
        //     let diffDays = moment.duration(send_date.diff(dateNow)).asDays();
        //     if (diffDays < -7) {
        //         return
        //     }
        // }

        this.setState({ isSubmit: !this.state.isSubmit });
    }

    onClickSubmitSend = () => {
        this.uploadImage(this.state.files);
    }

    uploadImage(files) {
        if (this.state.fileLoading) {
            return;
        }

        const code = this.props.match.params.code;
        if (!code || code.length == 0) {
            return;
        }
        if (!files || files.length == 0) {
            //추가 : 파일을 첨부해 주세요
            this.setState({
                alert: "Please attach files.",
                visibleAlert: !this.state.visibleAlert
            })
            return;
        }

        const self = this;

        const url = global.url_api + '/workbook/fileUpload/userUpload';
        const formData = new FormData();
        for (let i = 0; i < files.length; i++) {
            formData.append('file[]', files[i]);
        }
        formData.append('code', code);
        formData.append('message', this.state.message);

        const config = {
            headers: {
                'accept': 'application/json',
                'content-type': 'multipart/form-data',
                'Access-Control-Allow-Origin': '*',
            }
        }

        this.setState({ fileLoading: true });
        axios.post(url, formData, config)
            .then(function (response) {
                self.setState({ fileLoading: false });
                let data = response.data;
                if (data.result) {
                    //성공
                    self.loadEmailInfo(); //정보 다시 불러오기

                    self.setState({
                        message: "memo",
                        isSubmit: false,
                        alert: "Upload complete!",
                        visibleAlert: !self.state.visibleAlert
                    });
                    document.getElementById('file').value = "";
                } else {
                    //실패
                    //추가 : 실패 팝업 띄우기
                    self.setState({
                        alert: "Please try again.",
                        visibleAlert: !self.state.visibleAlert
                    })
                }
            })
            .catch(function (err) {
                self.setState({ fileLoading: false });
            })
    };

    onChangeMessage = (e) => {
        this.setState({ message: e.target.value });
    }

    render() {
        const getData = this.state.getData;

        //상단 종료 날짜
        let end_date = "";
        if (getData.send_date) {
            let send_date = moment(getData.send_date);
            end_date = send_date.add(7, 'days').format("ll");
        }
        let fileUrl = getData.fileUrl;

        //7일 지났는지 체크
        // let isEnd = false;
        // if (getData.send_date) {
        //     let dateNow = moment();
        //     let send_date = moment(getData.send_date);
        //     let diffDays = moment.duration(send_date.diff(dateNow)).asDays();
        //     if (diffDays < -7) {
        //         isEnd = true;
        //     }
        // }

        let sendText = "Submit";
        let LayoutFeedback;
        if (getData.get_type > 0) {
            let dateNow = moment();
            let get_date = moment(getData.get_date);
            let diffHours = moment.duration(get_date.diff(dateNow)).asHours();
            if (diffHours < -3) {
                sendText = "Completed"; //올린지 3시간 지남
            } else {
                sendText = "Reupload files";
            }

            LayoutFeedback = (
                <div className="feedback">
                    <h2>The file upload has been completed</h2>
                    <p>1:1 feedback of worksheets will be provided in 3 working days.<br />We’ll notify you via email when feedback is ready 😊</p>
                    <p>{'\u203B'}{'\u00A0'}You can re-upload the worksheets in 3 hours. Please send an inquiry to the email address below for re-uploading after 3 hours passed since the first submit of the file.</p>
                    <p style={{ fontWeight: '500' }}>Contact us: <a style={{ color: '#666', borderBottomWidth: 0 }} href="mailto:boomco@boomco.org" >boomco@boomco.org</a></p>
                </div>
            )
        }

        if (getData.get_type > 0 && getData.edit_type > 0) {
            let tutor_message = getData.edit_data.message;
            let tutor_file = getData.edit_data.files ? JSON.parse(getData.edit_data.files) : [];
            let tutorFileUrl = "";
            if (tutor_file.length > 0) {
                tutorFileUrl = tutor_file[0];
            }

            LayoutFeedback = (
                <div className="feedback">
                    <h2>Feedback</h2>
                    <p>{tutor_message}</p>
                    <div style={{ width: '100%' }}>
                        <img src={"/write/submit_icon_dot.png"} alt="dot" style={{ display: 'block', width: 15, height: 'auto', margin: 'auto' }} />
                        <img src={"/write/submit_icon_arrow.png"} alt="bottom arrow" style={{ display: 'block', width: 20, height: 'auto', margin: '30px auto' }} />
                        <a target="_blank" href={tutorFileUrl}>Download the feedbacks</a>
                    </div>
                </div>
            )
        }

        let LayoutButtons = (
            <Container style={{ marginTop: '3%', marginBottom: '10%' }}>
                <Row>
                    <Col xs={0} sm={0} md={2} lg={3}></Col>
                    <Col xs={6} sm={6} md={4} lg={3}>
                        <a target="_blank" href={fileUrl} download>
                            <div className="button1">Download</div>
                        </a>
                    </Col>
                    <Col xs={6} sm={6} md={4} lg={3}>
                        <a onClick={this.onClickSubmitOnoff}>
                            <div className="button2">{sendText}</div>
                        </a>
                    </Col>
                    <Col xs={0} sm={0} md={2} lg={3}></Col>
                </Row>
            </Container>
        )

        //7일 지났는지 체크
        // if (isEnd) {
        //     LayoutButtons = (
        //         <div style={{ marginTop: '3%', marginBottom: '6%' }}>
        //             <div className="button2" style={{ width: 220, marginLeft: 'auto', marginRight: 'auto' }}>7 days have passed</div>
        //         </div>
        //     )
        // }

        return (
            <div id="write_submit">
                <div id="page">
                    <div id="top">
                        <div className="inner">
                            <Container className="header">
                                <Row>
                                    <Col xs={6} sm={6} md={6} lg={6}>
                                        <img src={"/write/submit_logo.png"} alt="boomco logo" style={{ width: 150 }} />
                                    </Col>
                                    <Col xs={6} sm={6} md={6} lg={6} style={{ textAlign: 'right' }}>
                                        <img src={"/write/submit_study.png"} alt="study icon" style={{ width: 70 }} />
                                    </Col>
                                </Row>
                            </Container>
                            <div className="title">
                                <h3>Due date: {end_date}</h3>
                                {/* <p style={{ color: '#ffde00', fontSize: 20 }}>{'\u203B'}{'\u00A0'}{"Holiday Notice : We will be closed from 10th Feb 2021 - 15th Feb 2021. We are back on 16th Feb 2021."}</p> */}
                                <h1>Worksheets of the week</h1>
                                <p>Please try your best to complete the worksheets</p>
                            </div>
                            <div className="how">
                                <div className="howContainer">
                                    <p className="howText" style={{ backgroundColor: '#000', color: '#fff' }}>...</p>
                                </div>
                                <div className="howContainer">
                                    <p className="howText">Download the weekly worksheets.</p>
                                    <p className="howStep1">1</p>
                                </div>
                                <div className="howContainer" style={{ marginLeft: '6%' }}>
                                    <p className="howText">Print them or use iPad and complete the worksheets.</p>
                                    <p className="howStep2">2</p>
                                </div>
                                <a className="howLink" href="https://docs.google.com/document/d/1kfZKc9MdhNzvH6bN0qXCApkiDwVfHi_01YFJOxXT9go/edit?usp=sharing" target="_blank">{'\u002A'}{'\u00A0'}How to study with worksheets {'\u005B'}Click{'\u005D'}</a>
                                <div className="howContainer">
                                    <p className="howText">Click the "Submit" button to upload the worksheets.</p>
                                    <p className="howStep3">3</p>
                                </div>
                                <div className="howContainer" style={{ marginLeft: '4%' }}>
                                    <p className="howText">{'\u00A0'}{'\u00A0'}Feedback will be returned in 3 working days.</p>
                                    <p className="howStep4">4</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="middle">
                        {LayoutButtons}

                        <div className="submit" style={this.state.isSubmit == true ? { width: '100%' } : { display: 'none' }}>
                            <h4 style={{ textAlign: 'left' }}>Upload the completed worksheets</h4>
                            <hr></hr>
                            <textarea id="memo" placeholder="memo" onChange={e => this.onChangeMessage(e)} />
                            <input type="file" id="file" multiple onChange={this.handleAttachFile} />
                            <a className="button3" onClick={this.onClickSubmitSend}
                                style={this.state.fileLoading == true ? { display: 'none' } : { display: '' }}>Submit</a>
                            <ClipLoader
                                loader={"FadeLoader"}
                                color={'#0013c0'}
                                loading={this.state.fileLoading}
                                css={{ display: 'block', margin: '4.5% auto' }}
                                size={50}
                                className={"loader"}
                            />
                        </div>
                        {LayoutFeedback}
                    </div>

                    <div id="bottom">
                        <p>Copyright 2021. boomco.</p>
                        <p>1:1 Customer Center: <strong><a href="mailto:boomco@boomco.org">boomco@boomco.org</a></strong></p>
                    </div>
                </div>

                {/* modal(경고문) */}
                <Modal
                    isOpen={this.state.visibleAlert}
                    onRequestClose={() => this.setState({ visibleAlert: false })}
                    className="Alert"
                    overlayClassName="Overlay"
                >
                    <Container>
                        <Row>
                            <Col xs={12} sm={12} md={12} lg={12} className="my-auto" style={{ textAlign: 'center' }}>
                                <div style={{ color: '#666' }}>{this.state.alert}</div>
                            </Col>
                        </Row>
                        <div className="submitConfirmClose" onClick={() => this.setState({ visibleAlert: !this.state.visibleAlert })}>Close</div>
                    </Container>
                </Modal>
            </div>
        )
    }
}


export default App;